import React from 'react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="border-y-4 border-brand-navy bg-white px-4 py-7" data-id="element-210" data-mp="3kpuirmacsxk5">
      <div className="mx-auto max-w-2xl" data-id="element-211" data-mp="3fznuxono1h2y">
        <h2 className="text-center font-display text-xl font-extrabold uppercase leading-tight text-brand-navy sm:text-2xl" data-id="element-212" data-mp="3fym86mxaf65e">
          Cosa dicono gli insegnanti
        </h2>
        <p className="mt-1 text-center text-[13px] font-bold text-brand-graphite" data-id="element-213" data-mp="36zimrcaneenq">
          ⭐⭐⭐⭐⭐ 4.9/5 — Valutato dagli Insegnanti
        </p>

        <div className="mt-4 space-y-3" data-id="element-214" data-mp="31yl5r31djqnt">
          {testimonials.map(t => <figure key={t.author} className="rounded-lg border-2 border-brand-green/30 bg-brand-cream p-4" data-id="element-215" data-mp="2x1kyiossghv4">
              <p className="text-[13px] leading-none" aria-hidden="true" data-id="element-216" data-mp="v9ga3nai02p5">
                ⭐⭐⭐⭐⭐
              </p>
              <blockquote className="mt-2 text-sm font-medium italic leading-snug text-brand-graphite" data-id="element-217" data-mp="qallg4punjx4">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-2.5 flex items-center gap-2.5 border-t border-brand-navy/10 pt-2.5" data-id="element-218" data-mp="h4n6uketiff5">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-navy font-display text-base font-extrabold text-white" data-id="element-219" data-mp="m2ygau17anwu">
                  {t.author.charAt(0)}
                </span>
                <span className="leading-tight" data-id="element-220" data-mp="zwpp2073y3ri">
                  <span className="block text-[13px] font-extrabold text-brand-navy" data-id="element-221" data-mp="zwy0rorhv314">
                    {t.author}
                  </span>
                  <span className="block text-[11px] font-semibold uppercase tracking-wide text-brand-graphite/70" data-id="element-222" data-mp="q6mlj62d17ex">
                    {t.role} — {t.location}
                  </span>
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}